import React from "react";

function AreaIcon(props: any) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 1.5H3C2.175 1.5 1.5 2.175 1.5 3V15C1.5 15.825 2.175 16.5 3 16.5H15C15.825 16.5 16.5 15.825 16.5 15V3C16.5 2.175 15.825 1.5 15 1.5ZM3 3H6V10.5H3V3ZM3 15V12H6V15H3ZM15 15H7.5V7.5H15V15ZM15 6H7.5V3H15V6Z"
        fill="#91A4B7"
      />
    </svg>
  );
}

export default AreaIcon;
